import { useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get } from "@utils/axios_api";

const fetchDeptList = async (params) => {
  const response = await get("/deptList", { params });
  return response;
};

export function useDeptList() {
  const methods = useForm({
    defaultValues: {
      searchCnd: '',
      searchWrd: '',
      createStDate: null,
      createEndDate: null,
    },
    shouldFocusError: false, // Focus 방지
  });

  const { handleSubmit, watch } = methods;

  const [committedSearch, setCommittedSearch] = useState({
    searchCnd: "",
    searchWrd: "",
    createStDate: "",
    createEndDate: "",
  });

  const [pageIndex, setPageIndex] = useState(1);
  const recordCountPerPage = 5;

  const { searchCnd, searchWrd, createStDate, createEndDate } = committedSearch;


  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["selectDeptList", committedSearch, pageIndex],
    queryFn: () =>
      fetchDeptList({ searchCnd, searchWrd, createStDate, createEndDate, pageIndex, recordCountPerPage, }),
      keepPreviousData: true,
      staleTime: 600000,
  });

  const onSubmit = (values) => {
    setCommittedSearch({
      searchCnd: values.searchCnd,
      searchWrd: values.searchWrd,
      createStDate: values.createStDate ? values.createStDate + " 00:00:00" : "",
      createEndDate: values.createEndDate ? values.createEndDate + " 23:59:59" : "",
    });
    setPageIndex(1);
  };

  const handlePageChange = (targetPage) => {
    setPageIndex(targetPage);
  };

  return {
    methods,
    handleSubmit,
    watch,
    data,
    isLoading,
    isError,
    error,
    onSubmit,
    handlePageChange,
    pageIndex,
    recordCountPerPage,
  };
}
